/*jshint bitwise: false*/

(function(window: any) {
    'use strict';

    window.successStatus = 'success';
    window.errorStatus = 'error';

    var getFriendlyFileSizeDisplay = function(a:any,b:any,c:any,d:any,e:any){
        return (b = Math, c = b.log, d = 1024, e = c(a) / c(d)|0, a / b.pow(d,e)).toFixed(2) + ' ' + (e ? 'KMGTPEZY'[--e] + 'B' : 'Bytes');
    };

    window.getFriendlyFileSizeDisplay = getFriendlyFileSizeDisplay;

    // TODO: TRANSLATE
    var standardPageValidationError = 'Please make the changes marked.';
    window.standardPageValidationError = standardPageValidationError;
})(window);
